var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarningSupport = function SvgIconWarningSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__a)",
    d: "M11.279 22.413a89 89 0 0 1-7.77-.325 1.87 1.87 0 0 1-1.563-2.578 64.6 64.6 0 0 1 4.925-9.533 67 67 0 0 1 3.667-5.289 1.872 1.872 0 0 1 2.97 0 67 67 0 0 1 3.648 5.258 64.7 64.7 0 0 1 4.906 9.474 1.872 1.872 0 0 1-1.565 2.582c-3.11.273-6.2.411-9.218.411"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__b)",
    d: "M20.71 13.252v-.136a.91.91 0 0 1 .849-.908l1.468-.1a.91.91 0 0 1 .973.908v.337a.91.91 0 0 1-.973.908l-1.468-.1a.91.91 0 0 1-.848-.909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__c)",
    d: "m19.579 8.887-.068-.117a.91.91 0 0 1 .28-1.21l1.221-.822a.91.91 0 0 1 1.296.3l.17.292a.91.91 0 0 1-.39 1.273l-1.321.647a.91.91 0 0 1-1.189-.363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__d)",
    d: "m16.415 5.674-.118-.067a.91.91 0 0 1-.362-1.189l.647-1.322a.91.91 0 0 1 1.272-.388l.292.169a.91.91 0 0 1 .3 1.296l-.821 1.221a.91.91 0 0 1-1.21.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__e)",
    d: "M3.289 13.252v-.136a.91.91 0 0 0-.848-.908l-1.469-.1a.91.91 0 0 0-.972.908v.337a.91.91 0 0 0 .972.908l1.469-.1a.91.91 0 0 0 .848-.909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__f)",
    d: "m4.422 8.887.068-.117a.91.91 0 0 0-.28-1.21l-1.222-.822a.91.91 0 0 0-1.296.3l-.168.292a.91.91 0 0 0 .388 1.273l1.322.647a.91.91 0 0 0 1.188-.363"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-warning-support_svg__g)",
    d: "m7.585 5.674.118-.067a.91.91 0 0 0 .362-1.189l-.647-1.322a.91.91 0 0 0-1.272-.388l-.292.169a.91.91 0 0 0-.3 1.296l.821 1.221a.91.91 0 0 0 1.21.28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.48 8.942q.525-.053 1.05 0a.894.894 0 0 1 .8.86q.08 2.182 0 4.366a.894.894 0 0 1-.8.86q-.525.053-1.05 0a.894.894 0 0 1-.798-.86 60 60 0 0 1 0-4.366.894.894 0 0 1 .798-.86M11.506 16.625q.5-.024 1 0c.458.022.827.392.848.851q.03.672 0 1.344a.894.894 0 0 1-.849.85q-.5.024-1 0a.894.894 0 0 1-.848-.85q-.03-.672 0-1.344c.02-.46.39-.829.848-.85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__a",
    x1: 1.803,
    x2: 18.059,
    y1: 13.185,
    y2: 4.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__b",
    x1: 20.711,
    x2: 22.926,
    y1: 13.184,
    y2: 11.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__c",
    x1: 19.389,
    x2: 21.892,
    y1: 7.963,
    y2: 6.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__d",
    x1: 15.842,
    x2: 18.233,
    y1: 4.191,
    y2: 3.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__e",
    x1: 0,
    x2: 2.215,
    y1: 13.184,
    y2: 11.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__f",
    x1: 1.401,
    x2: 3.905,
    y1: 7.963,
    y2: 6.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-warning-support_svg__g",
    x1: 5.398,
    x2: 7.789,
    y1: 4.191,
    y2: 3.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })))));
};
export default SvgIconWarningSupport;